import React, { memo, useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';

function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function ChartStatisticalVol({ indexDetail, t, theme }) {
  const abortController = new AbortController();

  const DEFAULT_OPTION = {
    // grid: { top: 10, right: 40, bottom: 10, left: 40 },
    color: ['#0FC786', '#F5465C', '#F0B90B'],
    tooltip: {
      show: false,
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
    },
    legend: {
      show: false,
      orient: 'vertical',
      left: 'left',
    },
    series: [
      {
        name: 'Mã tăng giảm',
        type: 'pie',
        radius: ['50%', '70%'],
        top: '36px',
        height: '145px',
        left: 'center',
        width: 300,
        itemStyle: {
          borderWidth: 0,
        },
        data: [],
        label: {
          color: theme === 'dark' ? '#ECECEC' : '#000000',
          fontSize: 10,
          fontWeight: 400,
          textBorderColor: theme === 'dark' ? '#ECECEC' : '#000000',
          fontFamily: 'Roboto',
        },
        // emphasis: {
        //   itemStyle: {
        //     shadowBlur: 10,
        //     shadowOffsetX: 0,
        //     shadowColor: 'rgba(0, 0, 0, 0.5)'
        //   }
        // }
      },
    ],
  };

  const [option, setOption] = useState(DEFAULT_OPTION);

  const preIndexDetail = usePrevious(indexDetail);

  useEffect(() => {
    // _mapDataToState();

    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    if (indexDetail && !_.isEqual(indexDetail, preIndexDetail)) {
      _mapDataToState();
    }
  }, [indexDetail]);

  function _mapDataToState() {
    const newOption = _.cloneDeep(option);

    // // log(newOption);
    const _data = [
      {
        value: indexDetail?.Advances,
        name: t('algo.bdkt.txt-advance') + ' (' + indexDetail?.Advances + ')',
      },
      {
        value: indexDetail?.Declines,
        name: t('algo.bdkt.txt-decline') + ' (' + indexDetail?.Declines + ')',
      },
      {
        value: indexDetail?.NoChange,
        name: t('algo.bdkt.txt-no-change') + ' (' + indexDetail?.NoChange + ')',
      },
    ];

    newOption.series[0].data = _data;

    setOption(newOption);
  }

  return (
    <ReactECharts
      option={option}
      style={{
        height: '200px',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartStatisticalVol);
